import { render, staticRenderFns } from "./PlanPageBarriers.vue?vue&type=template&id=531bdb66&scoped=true&"
import script from "./PlanPageBarriers.vue?vue&type=script&lang=js&"
export * from "./PlanPageBarriers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531bdb66",
  null
  
)

export default component.exports